
































import Vue from 'vue';
import SidePage from 'common/components/ui/SidePage/index.vue';
import TaskPage from './TaskPage.vue';
import { getTaskDesc, TaskType } from '../models/TaskType';
import commonClient from '../apis';
import commonVuex from '../vuex/common';

enum TaskStatus {
  Ing = 0,
  Done = 1,
  Failure = -1,
}

const taskStatus: number | undefined = undefined;
const taskJob: any | null = null;

export default Vue.extend({
  mixins: [commonVuex],
  components: {
    SidePage,
    TaskPage,
  },
  data() {
    return {
      taskIngImg: require('assets/img/task.svg'),
      taskDoneImg: require('assets/img/task-done.svg'),
      taskFailureImg: require('assets/img/task-error.svg'),
      showTaskPage: false,
      taskStatusDesc: '',
      taskStatus,
      TaskStatus,
      taskJob,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    'hasLoginAccount'() {
      if (this.hasLoginAccount) {
        this.checkTaskStatus();
      } else {
        clearInterval(this.taskJob);
      }
    },
  },
  methods: {
    hideTaskPage() {
      this.showTaskPage = false;
    },
    checkTaskStatus() {
      this.taskJob = setInterval(() => {
        if (this.account && this.show) {
          commonClient.getUnconfirmedTasks().success(r => {
            if (r.length > 0) {
              const sucs = r.filter((r: any) => r.result === 0);
              const fals = r.filter((r: any) => r.result === -1);
              const ings = r.filter((r: any) => r.result === null);
              if (fals.length > 0) {
                this.taskStatus = TaskStatus.Failure;
              } else {
                this.taskStatus = sucs.length > 0 ? TaskStatus.Done : TaskStatus.Ing;
              }
              this.setTaskStatusDesc(sucs, fals, ings);
              this.$store.commit('SHOW_TASK_ENTRY', true);
            } else {
              this.$store.commit('SHOW_TASK_ENTRY', false);
            }
          });
        }
      }, 10000);
    },
    getTaskTypes(tasks: Array<any>): Array<number> {
      const descArr: any = [];
      for (const t of tasks) {
        if (!descArr.includes(t['taskType'])) {
          descArr.push(t['taskType']);
        }
      }
      return descArr;
    },
    displayTaskDescs(taskTypes: Array<TaskType>): string {
      return taskTypes.map((r: any) => getTaskDesc(r)).join('、');
    },
    setTaskStatusDesc(
      successList: Array<object>,
      failureList: Array<object>,
      ingList: Array<object>) {
      const descList = [];
      if (successList.length > 0) {
        const sDesc = this.displayTaskDescs(this.getTaskTypes(successList)) + '任务已经完成';
        descList.push(sDesc);
      }
      if (ingList.length > 0) {
        const iDesc = this.displayTaskDescs(this.getTaskTypes(ingList)) + '任务仍在进行中';
        descList.push(iDesc);
      }
      if (failureList.length > 0) {
        const fDesc = this.displayTaskDescs(this.getTaskTypes(failureList)) + '任务执行失败';
        descList.push(fDesc);
      }
      this.taskStatusDesc = descList.join('，') + '。';
    },
  },
  beforeDestroy() {
    if(this.taskJob) {
      clearInterval(this.taskJob);
    }
  },
  mounted() {
    if (this.hasLoginAccount) {
      this.checkTaskStatus();
    }
  },
});
